"use client";

import type { TenantConfig } from "@/utils/enterprise-theme";
import { createContext, useContext, type ReactNode } from "react";

interface ThemeContextValue {
  theme: TenantConfig;
}

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

interface ThemeProviderProps {
  theme: TenantConfig;
  children: ReactNode;
}

export const ThemeProvider = ({ theme, children }: ThemeProviderProps) => {
  return <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>;
};

export const useTheme = (): TenantConfig => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context.theme;
};
